export default __webpack_public_path__ + "static/benefitImg-e7976d60cfab07534962768f019f2dcd.png";